import { useState } from "react";
import { useSelector } from "react-redux";
import EmptyDataOverlay from "../../../components/empty-data-overlay";
import {
  getTeamMemberMonthlyReportsState,
  TeamMemberMonthlyReportsResponse,
} from "../../../redux/features/report-slice";
import { ArrowDownOutlined } from "../../../components/icons/arrow-down-outlined";
import WeeklyReportsTimeline from "./reports-timeline";
import { fractionOfDayToTimeString } from "../../../core/utils";

export default function MonthlyReportTab() {
  const teamMemberReports = useSelector(getTeamMemberMonthlyReportsState).data;

  const [toggleTaskGroup, setToggleTaskGroup] = useState<{
    [id: string]: boolean;
  }>({});

  return (
    <div
      className="space-y-4 overflow-auto"
      style={{
        height: "calc(100% - 58px)",
      }}
    >
      {teamMemberReports.length > 0 ? (
        teamMemberReports.map(
          (report: TeamMemberMonthlyReportsResponse, index: number) => {
            const orgName = report.taskGroup.taskFunction.organization.name;
            const orgColor =
              orgName === "Head Office"
                ? "#7d003c"
                : orgName === "HCM Office"
                ? "#0e7ab0"
                : "#a37402";
            return (
              <div
                key={index}
                className={`border border-divider rounded-lg cursor-pointer hover:bg-action-hover ${
                  toggleTaskGroup[report.taskGroup.id]
                    ? "bg-action-hover"
                    : "bg-background-paper"
                }`}
              >
                <div
                  className="flex items-center justify-between p-4"
                  onClick={() => {
                    setToggleTaskGroup((prevState) => ({
                      ...prevState,
                      [report.taskGroup.id]: !prevState[report.taskGroup.id],
                    }));
                  }}
                >
                  <div className="w-8/12 flex items-center">
                    <ArrowDownOutlined
                      className={`h-4 mr-4 transition-transform duration-300 ${
                        toggleTaskGroup[report.taskGroup.id]
                          ? "transform rotate-180"
                          : ""
                      }`}
                    />
                    <div className="w-11/12 font-medium">
                      <label className="hover:underline cursor-pointer">
                        {report.taskGroup.title}
                      </label>
                      <div className="flex items-center space-x-1">
                        <label
                          className="text-xs whitespace-nowrap font-medium"
                          style={{ color: orgColor }}
                        >
                          {report.taskGroup.taskFunction.organization.name}
                        </label>
                        <label>•</label>
                        <label className="text-xs line-clamp-1 text-text-title">
                          {report.taskGroup.taskFunction.title}
                        </label>
                        {report.taskGroup.branch !== null && (
                          <label className="text-xs whitespace-nowrap text-text-title">
                            {`/ ${report.taskGroup.branch.name}`}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w-2/12 flex flex-col">
                    <label className="text-sm text-text-title">
                      Total Duration
                    </label>
                    <label className="text-text-primary font-medium">
                      {report.totalDuration}
                    </label>
                  </div>
                  <div className="w-2/12 flex flex-col">
                    <label className="text-sm text-text-title">
                      Total Quantity
                    </label>
                    <label className="text-text-primary font-medium">
                      {report.totalQuantity}
                    </label>
                  </div>
                  <div className="w-2/12 flex flex-col">
                    <label className="text-sm text-text-title">Avg. Time</label>
                    <label className="text-text-primary font-medium">
                      {fractionOfDayToTimeString(
                        report.totalDuration /
                          (report.totalQuantity !== 0
                            ? report.totalQuantity
                            : 1)
                      )}
                    </label>
                  </div>
                </div>
                <div
                  className={`${
                    toggleTaskGroup[report.taskGroup.id]
                      ? "slide-down"
                      : "slide-up overflow-hidden"
                  }`}
                >
                  <WeeklyReportsTimeline reports={report.reports} />
                </div>
              </div>
            );
          }
        )
      ) : (
        <EmptyDataOverlay label="No Reports found" exClassName="h-96" />
      )}
    </div>
  );
}
